import './index.scss';

const CustomButton = ({ children, handleClick, type, selected, btnColor, isDisabled }) => (
  <button
    style={{ backgroundColor: btnColor, borderColor: btnColor, cursor: isDisabled ? 'not-allowed' : 'pointer' }}
    onClick={handleClick}
    className={`custom-button ${type} ${selected}`}
    disabled={isDisabled}
  >
    {children}
  </button>
);

export default CustomButton;
